import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { IContentSecurityPolicy } from './content-security-policy';

export function generateContentSecurityPolicy(policyContent: IContentSecurityPolicy): string {
  return `
    default-src 'self';
    style-src 'self' ${policyContent.styleSrc?.unsafeInLine ? `'unsafe-inline'` : ''} ${policyContent.styleSrc?.src ?? ''};
    script-src 'self' ${policyContent.scriptSrc?.unsafeInLine ? `'unsafe-inline'` : ''} ${policyContent.scriptSrc?.unsafeEval ? `'unsafe-eval'` : ''} ${policyContent.scriptSrc?.src ?? ''};
    img-src 'self'  ${policyContent.imgSrc ?? ''};
    frame-src 'self' ${policyContent.frameSrc ?? ''};
    connect-src 'self' ${policyContent.connectSrc ?? ''};
    font-src 'self' ${policyContent.fontSrc ?? ''};
    ${policyContent.upgradeInsecureRequests ? 'upgrade-insecure-requests;' : ''}
  `.trim();
}
@Injectable({
  providedIn: 'root'
})
export class TagInjectorService {
  private rendererFactory: RendererFactory2 = inject(RendererFactory2);
  private renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);

  public addMetaTagSecurityPolicy(policy: IContentSecurityPolicy) {
    const metaTag = this.renderer.createElement('meta');
    this.renderer.setAttribute(metaTag, 'http-equiv', 'Content-Security-Policy');
    const content = generateContentSecurityPolicy(policy);
    this.renderer.setAttribute(metaTag, 'content', content);
    const head = this.renderer.selectRootElement('head', true);
    const firstChild = head.firstChild;
    if (firstChild) {
      this.renderer.insertBefore(head, metaTag, firstChild);
    } else {
      this.renderer.appendChild(head, metaTag);
    }
  }

  injectLinkElement(href: string, rel: string, type?: string) {
    const linkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(linkElement, 'href', href);
    this.renderer.setAttribute(linkElement, 'rel', rel);
    if (type) {
      this.renderer.setAttribute(linkElement, 'type', type);
    }
    this.renderer.appendChild(document.head, linkElement);
  }

  injectScriptElement(src: string, type = 'text/javascript') {
    const scriptElement = this.renderer.createElement('script');
    this.renderer.setAttribute(scriptElement, 'src', src);
    this.renderer.setAttribute(scriptElement, 'type', type);
    this.renderer.appendChild(document.head, scriptElement);
  }

  injectScript(scriptContent: string) {
    const scriptElement = this.renderer.createElement('script');
    this.renderer.setAttribute(scriptElement, 'type', 'text/javascript');
    scriptElement.text = scriptContent;
    this.renderer.appendChild(document.head, scriptElement);
  }

  injectHtmlComment(comment: string) {
    const commentNode = this.renderer.createComment(comment);
    const head = this.renderer.selectRootElement('head', true);
    this.renderer.appendChild(head, commentNode);
  }
}
